module.exports = __webpack_public_path__ + "static/media/binggrae-banana.d0226058.jpg";